import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CompletedResourceResponse } from '../../../user/user';

export const deliveryOverviewBaseUrl = environment.deliveryOverviewApiUrl;
export const projectsOverviewBaseUrl = `${deliveryOverviewBaseUrl}/project-overview`;

@Injectable({
  providedIn: 'root',
})
export class ProjectsOverviewApiService {
  constructor(private http: HttpClient) {}

  getProjects(ids: string[]) {
    return this.http.post(
      projectsOverviewBaseUrl,
      { ids },
      {
        observe: 'events',
        responseType: 'text',
        reportProgress: true,
        headers: {
          Accept: 'text/event-stream',
        },
      },
    );
  }

  markProjectAsComplete = (id: string) => {
    return this.http.post<CompletedResourceResponse>(
      `${deliveryOverviewBaseUrl}/resources/${id}/completed`,
      {},
    );
  };
}
